/* PC Praha – filtry a řazení na kolekcích ASIC (23. 10. 2026), markup: snippets/pcp-af.liquid, data karet: snippets/pcp-af-item.liquid.
   – Všechny produkty kolekce jsou v HTML (paginate by 250); má-li kolekce víc stránek, dočtou se přes Section Rendering API
     (?section_id=…&page=N) a připojí se do mřížky před prvním filtrováním.
   – Návratnost a zisk / den: z panelu karty (.pcp-cy__panel: data-rev, data-pw, data-price-h / data-price-d → PCP.tfPrice) přes PCP.tfCalc
     (assets/pcp-tariff.js – stejný výpočet jako na kartách) s cenou elektřiny z přepínače nad nabídkou (PCP.tariff,
     událost „pcp:tariff“); bez přepínače = data-kwh (metapole pcpraha.karty_kwh).
   – Produkty bez ceny (data-af-a) nejsou ve filtrech návratnost / zisk / cena a při řazení podle návratnosti, zisku a ceny
     jsou na konci.
   – Stav (filtry + řazení) je v URL (history.replaceState): navratnost, zisk, spotreba, mince, chlazeni, pouziti, hluk,
     vyrobce, stav, dostupnost, cena_od, cena_do (Kč), razeni (výchozí „navratnost“ se do URL nepíše).
   – Mobil (< 750 px): panel filtrů je zásuvka (role=dialog) za tlačítkem „Filtry“; desktop: skupiny jako rozbalovací nabídky. */
(function () {
  if (customElements.get('pcp-af')) return;
  var P = window.PCP = window.PCP || {};
  var MAP = {
    chlazeni: { vzduch: 'air', hydro: 'hydro', imerze: 'imm' },
    stav: { novy: 'new', bazar: 'used' },
    dostupnost: { skladem: 's', predobjednavka: 'p', 'na-dotaz': 'd' }
  };
  var MULTI = ['spotreba', 'mince', 'chlazeni', 'pouziti', 'hluk', 'vyrobce', 'stav', 'dostupnost'];
  var SINGLE = ['navratnost', 'zisk'];
  var SORTS = ['navratnost', 'zisk', 'spotreba', 'efektivita', 'cena', 'cena-desc', 'nejnovejsi'];
  var DEF_SORT = 'navratnost';
  var mq = window.matchMedia('(max-width: 749px)');
  /* výpočet zisku a návratnosti je jen v assets/pcp-tariff.js (PCP.tfCalc, načtený před tímto souborem) */
  var calc = function (rev, pw, price, kwh) { return P.tfCalc(rev, pw, price, kwh); };
  /* cena pro návratnost podle režimu elektřiny (Na hosting bez DPH / Doma s DPH) – taky jen v pcp-tariff.js (PCP.tfPrice) */
  var payPrice = function (it, mode, kwh, vat) { return P.tfPrice ? P.tfPrice(it.ph, it.pd, mode, kwh, vat).price : it.pp; };
  /* zobrazená cena „od“ na kartě v2 podle přepínače provozu a DPH (data-pmin-h / -d na .pcp-k2__p) – filtr ceny i řazení */
  var shownPrice = function (it, mode, kwh, vat) { return P.tfShown && it.dmin > 0 ? P.tfShown(it.hmin, it.dmin, mode, kwh, vat).price : it.p0; };
  var fill = function (s, v) { return String(s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (a, k) { return v[k] != null ? v[k] : a; }); };
  var wBucket = function (w) { return !(w > 0) ? '' : w <= 100 ? 'w1' : w <= 1500 ? 'w2' : w <= 3500 ? 'w3' : 'w4'; };
  var nBucket = function (db) { return !(db > 0) ? '' : db <= 40 ? 'n1' : db <= 60 ? 'n2' : 'n3'; };

  customElements.define('pcp-af', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.list = this.closest('results-list') || document;
      this.grid = this.list.querySelector('ul.product-grid');
      if (!this.grid) return;
      this.panel = this.querySelector('[data-af-panel]');
      this.openBtn = this.querySelector('[data-af-open]');
      this.sortSel = this.querySelector('[data-af-sort]');
      this.pmin = this.querySelector('[data-af-pmin]');
      this.pmax = this.querySelector('[data-af-pmax]');
      this.groups = {};
      this.querySelectorAll('.pcp-af__g[data-g]').forEach((g) => { this.groups[g.dataset.g] = g; });
      this.state = this.readUrl();
      this.kwh = P.tariff ? P.tariff.kwh : (parseFloat(this.dataset.kwh) || 0);
      this.mode = P.tariff ? P.tariff.mode : '';
      this.vat = P.tariff ? P.tariff.vat !== false : true;
      this.collect();
      this.orderOpts('mince');
      this.syncInputs();
      this.bind();
      this.run(true);
      this.loadMore();
      if (customElements.whenDefined) customElements.whenDefined('pcp-tariff').then(() => { this.placeTf(); this.tfChip(); });
    }

    /* ---------- přepínač provozu a DPH (sections/pcp-provoz.liquid) na telefonu v zásuvce Filtry ----------
       Pod 750 px se řádky přepínače (.pcp-tf__rows z pcp-tariff[data-url]) přesunou na začátek zásuvky (do posuvné části se skupinami) a nad počet
       výsledků se ukáže čip se souhrnem („Na našem hostingu · 1,14 Kč/kWh · bez DPH“), který zásuvku otevře.
       Na širší obrazovce se řádky vrátí na původní místo. Posluchače tlačítek zůstávají (přesouvá se jen DOM). */
    placeTf() {
      var tf = document.querySelector('pcp-tariff[data-url]'), rows = this._tfRows || (tf && tf.querySelector('.pcp-tf__rows'));
      if (!rows) return;
      this._tfRows = rows;
      if (!this._tfHome) { this._tfHome = document.createComment('pcp-tf-rows'); rows.parentNode.insertBefore(this._tfHome, rows); }
      var box = tf && tf.closest('.pcp-pv');
      if (mq.matches) {
        if (!this._tfSlot) {
          this._tfSlot = document.createElement('div');
          this._tfSlot.className = 'pcp-af__tf';
          var gs = this.panel.querySelector('.pcp-af__groups');
          if (gs) gs.insertBefore(this._tfSlot, gs.firstChild); else this.panel.appendChild(this._tfSlot);
        }
        if (rows.parentNode !== this._tfSlot) this._tfSlot.appendChild(rows);
        if (box) box.classList.add('is-moved');
      } else {
        if (rows.parentNode !== this._tfHome.parentNode) this._tfHome.parentNode.insertBefore(rows, this._tfHome.nextSibling);
        if (box) box.classList.remove('is-moved');
      }
    }
    tfChip() {
      if (!document.querySelector('pcp-tariff[data-url]') || !P.tariff || !P.tariff.label) return;
      if (!this._tfChip) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pcp-af__tfchip';
        b.setAttribute('aria-controls', this.panel.id);
        b.addEventListener('click', () => this.drawer(true));
        var st = this.querySelector('.pcp-af__status');
        if (st) st.insertBefore(b, st.firstChild); else this.appendChild(b);
        this._tfChip = b;
      }
      var tl = document.querySelector('pcp-tariff[data-url]').getAttribute('data-t-chip') || '';
      this._tfChip.innerHTML = '<svg aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 4 14h7l-1 8 9-12h-7z"/></svg><span></span>';
      this._tfChip.querySelector('span').textContent = P.tariff.label;
      if (tl) this._tfChip.setAttribute('aria-label', tl + ': ' + P.tariff.label);
    }

    /* ---------- data ---------- */
    collect() {
      var n = 0;
      this.items = [...this.grid.querySelectorAll(':scope > li.product-grid__item')].map((li) => this.item(li, n++));
      this.byAlgo = {};
      this.items.forEach((it) => { this.byAlgo[it.al] = (this.byAlgo[it.al] || 0) + 1; });
      var rank = Object.keys(this.byAlgo).sort((a, b) => this.byAlgo[b] - this.byAlgo[a] || (a < b ? -1 : 1));
      this.algoRank = {};
      rank.forEach((a, i) => { this.algoRank[a] = i; });
    }
    /* mince / algoritmy: nejčastější v kolekci nahoře */
    orderOpts(g) {
      var box = this.groups[g], fs = box && box.querySelector('fieldset');
      if (!fs) return;
      var cnt = {};
      [...fs.querySelectorAll('.pcp-af__o')].forEach((l) => { var v = l.querySelector('input').value; cnt[v] = this.items.filter((it) => this.optMatch(g, v, it)).length; });
      [...fs.querySelectorAll('.pcp-af__o')].sort((a, b) => cnt[b.querySelector('input').value] - cnt[a.querySelector('input').value]).forEach((l) => fs.appendChild(l));
    }
    item(li, i) {
      var d = li.dataset, pn = li.querySelector('.pcp-cy__panel[data-rev]'), pe = li.querySelector('.pcp-k2__p[data-pmin-d]');
      return {
        el: li, i: i,
        p: +d.afP || 0, p0: +d.afP || 0, hmin: pe ? +pe.dataset.pminH || 0 : 0, dmin: pe ? +pe.dataset.pminD || 0 : 0, ask: d.afA === '1', w: +d.afW || 0, al: d.afAl || '', c: d.afC || '', u: d.afU || '',
        db: +d.afDb || 0, v: d.afV || '', st: d.afSt || '', av: (d.afAv || '').split(' '), e: +d.afE || 0, eu: d.afEu || '',
        t: +d.afT || 0,
        rev: pn ? +pn.dataset.rev : 0, pw: pn ? +pn.dataset.pw : 0, pp: pn ? +pn.dataset.price : 0,
        ph: pn ? +pn.dataset.priceH || 0 : 0, pd: pn ? (pn.dataset.priceD != null ? +pn.dataset.priceD || 0 : +pn.dataset.price || 0) : 0
      };
    }
    compute() {
      var kwh = this.kwh, mode = this.mode, vat = this.vat;
      this.items.forEach((it) => {
        it.p = shownPrice(it, mode, kwh, vat);
        if (it.ask || !(it.rev > 0)) { it.profit = null; it.m = null; return; }
        var price = payPrice(it, mode, kwh, vat), r = calc(it.rev, it.pw, price, kwh);
        it.profit = r.profit;
        it.m = price > 0 ? r.months : null;
      });
    }

    /* ---------- URL ---------- */
    readUrl() {
      var q = new URLSearchParams(location.search), s = { sort: DEF_SORT };
      SINGLE.forEach((k) => { var v = parseFloat(q.get(k)); s[k] = v > 0 ? v : null; });
      MULTI.forEach((k) => { s[k] = (q.get(k) || '').split(',').map((x) => x.trim()).filter(Boolean); });
      ['cena_od', 'cena_do'].forEach((k) => { var v = parseFloat(q.get(k)); s[k] = v >= 0 && q.get(k) !== '' && q.get(k) != null ? v : null; });
      var so = q.get('razeni');
      if (so && SORTS.indexOf(so) >= 0) s.sort = so;
      return s;
    }
    writeUrl() {
      if (!/^https?:/.test(location.protocol)) return;
      var u = new URL(location.href), q = u.searchParams, s = this.state;
      SINGLE.concat(MULTI, ['cena_od', 'cena_do', 'razeni']).forEach((k) => q.delete(k));
      SINGLE.forEach((k) => { if (s[k]) q.set(k, s[k]); });
      MULTI.forEach((k) => { if (s[k].length) q.set(k, s[k].join(',')); });
      if (s.cena_od != null) q.set('cena_od', Math.round(s.cena_od));
      if (s.cena_do != null) q.set('cena_do', Math.round(s.cena_do));
      if (s.sort !== DEF_SORT) q.set('razeni', s.sort);
      var url = u.pathname + (q.toString() ? '?' + q.toString().replace(/%2C/g, ',') : '') + u.hash;
      if (url !== location.pathname + location.search + location.hash) { try { history.replaceState(history.state, '', url); } catch (e) {} }
    }

    /* ---------- UI ↔ stav ---------- */
    groupInputs(g) { return this.groups[g] ? [...this.groups[g].querySelectorAll('input[type=checkbox],input[type=radio]')] : []; }
    syncInputs() {
      var s = this.state;
      SINGLE.forEach((g) => this.groupInputs(g).forEach((i) => { i.checked = s[g] ? +i.value === s[g] : i.value === ''; }));
      MULTI.forEach((g) => this.groupInputs(g).forEach((i) => { i.checked = s[g].indexOf(i.value) >= 0; }));
      if (this.sortSel) this.sortSel.value = s.sort;
      this.showPrice();
    }
    rate() { var c = P.cur || 'CZK', r = P.rate && P.rate[c]; return c !== 'CZK' && r > 0 ? r : 1; }
    showPrice() {
      var r = this.rate();
      if (this.pmin && document.activeElement !== this.pmin) this.pmin.value = this.state.cena_od != null ? Math.round(this.state.cena_od / r) : '';
      if (this.pmax && document.activeElement !== this.pmax) this.pmax.value = this.state.cena_do != null ? Math.round(this.state.cena_do / r) : '';
    }
    readPrice() {
      var r = this.rate(), a = parseFloat(this.pmin && this.pmin.value), b = parseFloat(this.pmax && this.pmax.value);
      this.state.cena_od = a >= 0 ? a * r : null;
      this.state.cena_do = b > 0 ? b * r : null;
    }
    bind() {
      Object.keys(this.groups).forEach((g) => {
        var box = this.groups[g], btn = box.querySelector('.pcp-af__gb');
        btn.addEventListener('click', (e) => { e.stopPropagation(); this.toggleGroup(g); });
        box.addEventListener('change', (e) => {
          var i = e.target;
          if (!i.matches('input[type=checkbox],input[type=radio]')) return;
          if (SINGLE.indexOf(g) >= 0) this.state[g] = i.value ? +i.value : null;
          else this.state[g] = this.groupInputs(g).filter((x) => x.checked).map((x) => x.value);
          this.run(false);
        });
      });
      var t = 0;
      [this.pmin, this.pmax].forEach((inp) => {
        if (!inp) return;
        inp.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { this.readPrice(); this.run(false); }, 250); });
        inp.addEventListener('change', () => { clearTimeout(t); this.readPrice(); this.run(false); });
      });
      if (this.sortSel) this.sortSel.addEventListener('change', () => { this.state.sort = this.sortSel.value; this.run(false); });
      this.querySelectorAll('[data-af-reset]').forEach((b) => b.addEventListener('click', () => this.reset()));
      this.querySelector('[data-af-chips]').addEventListener('click', (e) => {
        var b = e.target.closest('[data-chip]');
        if (!b) return;
        var g = b.dataset.chip, v = b.dataset.v;
        if (g === 'cena') { this.state.cena_od = null; this.state.cena_do = null; this.showPrice(); }
        else if (SINGLE.indexOf(g) >= 0) this.state[g] = null;
        else this.state[g] = this.state[g].filter((x) => x !== v);
        this.syncInputs();
        this.run(false);
      });
      this.openBtn.addEventListener('click', () => this.drawer(true));
      this.querySelectorAll('[data-af-close]').forEach((b) => b.addEventListener('click', () => this.drawer(false)));
      this.addEventListener('click', (e) => { if (e.target === this && this.classList.contains('is-drawer')) this.drawer(false); });
      document.addEventListener('click', (e) => {
        if (mq.matches) return;
        var open = this.querySelector('.pcp-af__g.is-open');
        if (open && !open.contains(e.target)) this.toggleGroup(null);
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (this.classList.contains('is-drawer')) { this.drawer(false); return; }
        var open = this.querySelector('.pcp-af__g.is-open');
        if (open) { this.toggleGroup(null); open.querySelector('.pcp-af__gb').focus(); }
      });
      this.panel.addEventListener('keydown', (e) => {
        if (e.key !== 'Tab' || !this.classList.contains('is-drawer')) return;
        var f = [...this.panel.querySelectorAll('button,input,select')].filter((x) => x.offsetParent !== null);
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      var onMq = () => { if (!mq.matches && this.classList.contains('is-drawer')) this.drawer(false); this.placeTf(); };
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      document.addEventListener('pcp:tariff', (e) => {
        var k = e.detail && e.detail.kwh, md = (e.detail && e.detail.mode) || '', vt = !(e.detail && e.detail.vat === false);
        this.tfChip();
        if (k == null || (k === this.kwh && md === this.mode && vt === this.vat)) return;
        this.kwh = k;
        this.mode = md;
        this.vat = vt;
        this.run(false, true);
      });
      document.addEventListener('pcp:currency', () => { this.showPrice(); this.renderChips(); });
    }
    toggleGroup(g) {
      Object.keys(this.groups).forEach((k) => {
        var box = this.groups[k], open = k === g ? !box.classList.contains('is-open') : (mq.matches ? box.classList.contains('is-open') : false);
        box.classList.toggle('is-open', open);
        box.querySelector('.pcp-af__gb').setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    drawer(open) {
      if (open && !mq.matches) return;
      this.classList.toggle('is-drawer', open);
      this.openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
        document.documentElement.classList.add('pcp-af-lock');
        var x = this.panel.querySelector('[data-af-close]');
        if (x) x.focus();
      } else {
        this.panel.removeAttribute('role');
        this.panel.removeAttribute('aria-modal');
        document.documentElement.classList.remove('pcp-af-lock');
        if (mq.matches) this.openBtn.focus();
      }
    }
    reset() {
      var s = this.state;
      SINGLE.forEach((k) => { s[k] = null; });
      MULTI.forEach((k) => { s[k] = []; });
      s.cena_od = null; s.cena_do = null;
      this.syncInputs();
      this.run(false);
    }

    /* ---------- filtr ---------- */
    match(it, skip) {
      var s = this.state;
      if (skip !== 'navratnost' && s.navratnost && !(it.m != null && it.m <= s.navratnost)) return false;
      if (skip !== 'zisk' && s.zisk && !(it.profit != null && it.profit >= s.zisk)) return false;
      if (skip !== 'spotreba' && s.spotreba.length && s.spotreba.indexOf(wBucket(it.w)) < 0) return false;
      if (skip !== 'mince' && s.mince.length && s.mince.indexOf(it.al) < 0) return false;
      if (skip !== 'chlazeni' && s.chlazeni.length && !s.chlazeni.some((v) => MAP.chlazeni[v] === it.c)) return false;
      if (skip !== 'pouziti' && s.pouziti.length && s.pouziti.indexOf(it.u) < 0) return false;
      if (skip !== 'hluk' && s.hluk.length && s.hluk.indexOf(nBucket(it.db)) < 0) return false;
      if (skip !== 'vyrobce' && s.vyrobce.length && s.vyrobce.indexOf(it.v) < 0) return false;
      if (skip !== 'stav' && s.stav.length && !s.stav.some((v) => MAP.stav[v] === it.st)) return false;
      if (skip !== 'dostupnost' && s.dostupnost.length && !s.dostupnost.some((v) => it.av.indexOf(MAP.dostupnost[v]) >= 0)) return false;
      if (skip !== 'cena' && (s.cena_od != null || s.cena_do != null)) {
        if (it.ask || !(it.p > 0)) return false;
        if (s.cena_od != null && it.p < s.cena_od) return false;
        if (s.cena_do != null && it.p > s.cena_do) return false;
      }
      return true;
    }
    optMatch(g, v, it) {
      switch (g) {
        case 'navratnost': return it.m != null && it.m <= +v;
        case 'zisk': return it.profit != null && it.profit >= +v;
        case 'spotreba': return wBucket(it.w) === v;
        case 'mince': return it.al === v;
        case 'chlazeni': return MAP.chlazeni[v] === it.c;
        case 'pouziti': return it.u === v;
        case 'hluk': return nBucket(it.db) === v;
        case 'vyrobce': return it.v === v;
        case 'stav': return MAP.stav[v] === it.st;
        case 'dostupnost': return it.av.indexOf(MAP.dostupnost[v]) >= 0;
      }
      return false;
    }
    counts() {
      Object.keys(this.groups).forEach((g) => {
        if (g === 'cena') return;
        var base = this.items.filter((it) => this.match(it, g));
        this.groupInputs(g).forEach((i) => {
          var n = i.closest('.pcp-af__o').querySelector('[data-af-n]');
          if (!n || i.value === '') return;
          var c = base.reduce((a, it) => a + (this.optMatch(g, i.value, it) ? 1 : 0), 0);
          n.textContent = c;
          i.closest('.pcp-af__o').classList.toggle('is-zero', c === 0 && !i.checked);
        });
        var sel = SINGLE.indexOf(g) >= 0 ? (this.state[g] ? 1 : 0) : (this.state[g] || []).length;
        var gc = this.groups[g].querySelector('[data-af-gc]');
        gc.textContent = sel || '';
        gc.hidden = !sel;
        this.groups[g].classList.toggle('is-active', !!sel);
      });
      var pg = this.groups.cena;
      if (pg) {
        var on = this.state.cena_od != null || this.state.cena_do != null, gc = pg.querySelector('[data-af-gc]');
        gc.textContent = on ? 1 : ''; gc.hidden = !on; pg.classList.toggle('is-active', on);
      }
    }

    /* ---------- řazení ---------- */
    key(it) {
      switch (this.state.sort) {
        case 'navratnost':
          if (it.ask) return [4, 0];
          if (it.m == null) return [3, 0];
          if (!(it.m < Infinity)) return [2, -(it.profit || 0)];
          return [1, it.m];
        case 'zisk':
          if (it.ask) return [3, 0];
          if (it.profit == null) return [2, 0];
          return [1, -it.profit];
        case 'spotreba': return it.w > 0 ? [1, it.w] : [2, 0];
        case 'efektivita': return it.e > 0 ? [1, this.algoRank[it.al] || 0, it.e] : [2, 0];
        case 'cena': return it.ask || !(it.p > 0) ? [2, 0] : [1, it.p];
        case 'cena-desc': return it.ask || !(it.p > 0) ? [2, 0] : [1, -it.p];
        case 'nejnovejsi': return [1, -it.t];
      }
      return [1, it.i];
    }
    sort() {
      var arr = this.items.map((it) => ({ it: it, k: this.key(it) }));
      arr.sort((a, b) => {
        for (var j = 0; j < Math.max(a.k.length, b.k.length); j++) {
          var x = a.k[j] || 0, y = b.k[j] || 0;
          if (x !== y) return x < y ? -1 : 1;
        }
        return a.it.i - b.it.i;
      });
      var cur = [...this.grid.querySelectorAll(':scope > li.product-grid__item')];
      var same = cur.length === arr.length && arr.every((o, j) => o.it.el === cur[j]);
      if (same) return;
      var frag = document.createDocumentFragment();
      arr.forEach((o) => frag.appendChild(o.it.el));
      this.grid.appendChild(frag);
    }

    /* ---------- běh ---------- */
    run(first, tariffOnly) {
      this.compute();
      var shown = 0;
      this.items.forEach((it) => {
        var ok = this.match(it, null);
        it.el.classList.toggle('pcp-af-hide', !ok);
        if (ok) shown++;
      });
      if (!tariffOnly || this.state.sort === 'navratnost' || this.state.sort === 'zisk' || this.state.sort === 'cena' || this.state.sort === 'cena-desc' || this.state.navratnost || this.state.zisk || this.state.cena_od != null || this.state.cena_do != null) this.sort();
      this.counts();
      var total = this.items.length;
      this.querySelector('[data-af-count]').textContent = fill(this.dataset.tShown, { n: shown, m: total });
      var ap = this.querySelector('[data-af-apply]');
      if (ap) ap.textContent = fill(this.dataset.tShowN, { n: shown });
      var any = this.active();
      this.querySelectorAll('.pcp-af__status [data-af-reset]').forEach((b) => { b.hidden = !any; });
      var badge = this.querySelector('[data-af-badge]');
      badge.textContent = any || '';
      badge.hidden = !any;
      this.querySelector('[data-af-empty]').hidden = shown > 0;
      this.renderChips();
      if (!first) this.writeUrl();
      else if (location.search) this.writeUrl();
    }
    active() {
      var s = this.state, n = 0;
      SINGLE.forEach((k) => { if (s[k]) n++; });
      MULTI.forEach((k) => { n += s[k].length; });
      if (s.cena_od != null || s.cena_do != null) n++;
      return n;
    }
    renderChips() {
      var box = this.querySelector('[data-af-chips]'), s = this.state, html = '';
      var rm = this.dataset.tRemove;
      var chip = (g, v, label) => {
        var t = label.replace(/\s+/g, ' ').trim();
        html += '<button type="button" class="pcp-af__chip" data-chip="' + g + '" data-v="' + v + '" aria-label="' + fill(rm, { f: t }).replace(/"/g, '&quot;') + '"><span>' + t.replace(/</g, '&lt;') + '</span><span aria-hidden="true">×</span></button>';
      };
      Object.keys(this.groups).forEach((g) => {
        if (g === 'cena') return;
        this.groupInputs(g).forEach((i) => {
          if (!i.checked || i.value === '') return;
          chip(g, i.value, i.closest('.pcp-af__o').querySelector('.pcp-af__ot').textContent);
        });
      });
      if (s.cena_od != null || s.cena_do != null) {
        var f = P.kc || function (x) { return Math.round(x) + ' Kč'; };
        chip('cena', '', this.dataset.tPrice + ': ' + (s.cena_od != null ? f(s.cena_od) : '0') + ' – ' + (s.cena_do != null ? f(s.cena_do) : '∞'));
      }
      box.innerHTML = html;
    }

    /* ---------- další stránky (kolekce nad 250 produktů) ---------- */
    loadMore() {
      var last = parseInt(this.grid.dataset.lastPage, 10) || 1;
      var sid = this.list.getAttribute && this.list.getAttribute('section-id');
      if (last < 2 || !sid) return;
      var jobs = [];
      for (var pg = 2; pg <= last; pg++) {
        var u = new URL(location.href);
        u.searchParams.set('page', pg);
        u.searchParams.set('section_id', sid);
        jobs.push(fetch(u.toString()).then((r) => r.text()));
      }
      Promise.all(jobs).then((htmls) => {
        var known = {};
        this.items.forEach((it) => { known[it.el.id] = 1; });
        htmls.forEach((h) => {
          var d = new DOMParser().parseFromString(h, 'text/html');
          d.querySelectorAll('ul.product-grid > li.product-grid__item').forEach((li) => {
            if (known[li.id]) return;
            known[li.id] = 1;
            var n = document.importNode(li, true);
            this.grid.appendChild(n);
            this.items.push(this.item(n, this.items.length));
          });
        });
        var pag = this.list.querySelector('.pagination, pagination-controls, [class*="pagination"]');
        if (pag) pag.hidden = true;
        this.collect();
        this.run(false);
        document.dispatchEvent(new CustomEvent('pcp:af-more'));
      }).catch(() => {});
    }
  });
})();
